import React from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import styles from '../../styles/views/components/RateLine.module.scss';

export default function RateLine({
  label,
  title,
  rate,
  onChange,
  name,
  isDisabled,
}) {
  const ratingScores = [5, 4, 3, 2, 1];
  return (
    <div className={styles.container}>
      <div className={styles.label}>{label}</div>
      <div className={styles.info}>
        <div className={styles.title}>{title}</div>
        <div className={styles.line}>
          <div className={styles.points}>
            {ratingScores.map((number) => {
              const id = nanoid();

              return (
                <React.Fragment key={number}>
                  <input
                    onClick={() => onChange(number)}
                    className={styles.input}
                    type="radio"
                    id={id}
                    name={name}
                    value={number}
                    disabled={isDisabled}
                  />
                  <label
                    className={[
                      (isDisabled ? styles.grayStar : styles.goldStar),
                      (number <= rate && !isDisabled) ? styles.filledStar : '',
                      (number <= rate && isDisabled) ? styles.filledGrayStar : '',
                    ].join(' ')}
                    htmlFor={id}
                  />
                </React.Fragment>
              );
            })}
          </div>

          <div className={styles.rate}>
            {rate} of 5
          </div>
        </div>
      </div>
    </div>
  );
}

RateLine.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  rate: PropTypes.number,
  onChange: PropTypes.func,
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
};

RateLine.defaultProps = {
  label: '',
  title: '',
  name: '',
  rate: 0,
  onChange: () => {},
  isDisabled: false,
};
